import React, { useEffect, useRef, useState } from 'react';
import { SCALES, getScaleSetting, resolveScale, setScale } from './index';
import { tr } from '../i18n';
// Same look as the language list (shared footer-menu styles).
import '../i18n/LanguageSwitcher.css';

// Footer "display size" list: 🔍 + current size; opens upwards.
export default function DisplaySizeMenu() {
  const [open, setOpen] = useState(false);
  const [setting, setSetting] = useState(getScaleSetting());
  const [, forceRender] = useState(0);
  const boxRef = useRef(null);

  // Close on a click outside or on Escape.
  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  // In Auto, keep the label right when the window is resized.
  useEffect(() => {
    if (setting !== 'auto') return undefined;
    const onResize = () => forceRender((n) => n + 1);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [setting]);

  const current = resolveScale(setting);
  const label = (s) => (s === 'auto' ? tr('Auto') : `${s}%`);

  return (
    <div className="lang-menu size-menu" ref={boxRef}>
      <button
        type="button"
        className="lang-menu__button"
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        title={tr('Display size')}
      >
        <i className="fas fa-search-plus" aria-hidden="true" />
        <span>{setting === 'auto' ? `${tr('Auto')} ${current}%` : `${current}%`}</span>
        <i className={`fas fa-chevron-${open ? 'down' : 'up'} lang-menu__chevron`} aria-hidden="true" />
      </button>

      {open && (
        <ul className="lang-menu__list" role="listbox" aria-label={tr('Display size')}>
          {SCALES.map((s) => (
            <li key={s} role="option" aria-selected={s === setting}>
              <button
                type="button"
                className={`lang-menu__item${s === setting ? ' is-active' : ''}`}
                onClick={() => {
                  setScale(s);
                  setSetting(s);
                  setOpen(false);
                }}
              >
                <span className="lang-menu__label">{label(s)}</span>
                {s === setting && <i className="fas fa-check" aria-hidden="true" />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
